import { AuthN, getConfig } from '@seek/online-identity';
import { useEffect, useRef } from 'react';
import { v4 as uuid } from 'uuid';

import Layout from 'src/components/Layout/Layout';
import { Page as PageName, useTrackingClient } from 'src/context/tracking';
import { useApplicationCorrelationId } from 'src/context/use-application-correlation-id';
import { useJobId } from 'src/context/useJobId';
import { useHubbleImpression } from 'src/hooks/useHubbleImpression';
import { FullScreenLoader } from 'src/ui/FullScreenLoader/FullScreenLoader';
import { SomethingWentWrong } from 'src/ui/SomethingWentWrong/SomethingWentWrong';
import { navigateToUrl } from 'src/utils';

import { useLinkoutUrl } from './hooks/useLinkoutUrl';

export function External() {
  const { applicationCorrelationId, newApplication: isNewApplication } =
    useApplicationCorrelationId();
  const jobId = useJobId();
  const trackingCorrelationId = useRef(uuid());
  const trackingClient = useTrackingClient({
    pageTitle: PageName.APPLY_LINKOUT,
    currentPage: PageName.APPLY_LINKOUT,
  });

  const { url, error, requireAuth } = useLinkoutUrl();

  useHubbleImpression(
    'job_apply_linkout_displayed',
    trackingCorrelationId.current,
    { applicationCorrelationId },
  );

  useEffect(() => {
    const trackLink = async () => {
      if (!isNewApplication) {
        const host = typeof window === 'object' ? window.location.host : '';
        const auth = new AuthN(getConfig('seekAnz-candidate', { host }));

        await auth.init();

        const user = await auth.getUser();
        const trackingVal = user['http://seek/claims/is_new_user']
          ? 'apply_flow_register_succeeded'
          : 'apply_flow_login_succeeded';

        trackingClient.trackLink({
          link: trackingVal,
          eventName: trackingVal,
          trackingCorrelationId: trackingCorrelationId.current,
        });
      }
    };

    trackLink();
  }, [trackingClient, isNewApplication, trackingCorrelationId]);

  if (error) {
    return (
      <Layout>
        <SomethingWentWrong
          error={error}
          type="linkout-redirect-failed"
          message="Linkout failed"
          jobId={jobId}
        />
      </Layout>
    );
  }

  // If we disable login before linkout, some linkouts still require auth
  if (!error && (url || requireAuth)) {
    navigateToUrl(url, true);
  }

  return <FullScreenLoader />;
}
